import { useStore, useStoreMap } from 'effector-react'
import { otherChargeModel, Form } from '~/entities/OtherCharges'
import { formatDateTimeForUI } from '~/shared/lib/date'

export function ViewOtherCharge() {
  const isLoading = useStore(otherChargeModel.requestOtherChargeFx.pending)

  const defaultValues = useStoreMap(
    otherChargeModel.$otherCharge,
    (otherCharge) => {
      const otherChargeDateTime = otherCharge?.getPenaltyDatetime()
      return {
        ...otherCharge?.getAttributes(),
        carBrandModel: otherCharge?.getBrandModel(),
        penaltyDatetime: otherChargeDateTime
          ? formatDateTimeForUI(otherChargeDateTime)
          : '',
      }
    },
  )

  return <Form isLoading={isLoading} defaultValues={defaultValues} />
}
